// extracted by mini-css-extract-plugin
module.exports =  {"infoIcon":"CFGyCNNOeW_iNqJA6nT6"};